import * as api from 'Shared/api/members';
import omit from 'lodash/omit';
import { tr } from 'Shared/utils/hooks/use-translation';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { showNotificationError } from 'Shared/helpers';
import { handleRequestError } from 'Shared/utils/handle-request-error';

export const getMembersAction = () => async dispatch =>
  handleRequestError(api.getMembers()).then(response => {
    dispatch({ type: 'GET_MEMBERS_RESPONSE', payload: { members: response.data } });
    dispatch({
      type: 'GET_MEMBERS_RESPONSE_NEW_STORE',
      payload: {
        user: response.data.map(item => {
          return { attributes: item };
        }),
      },
    });
  });

export const updateMemberAction = params => async (dispatch, getState) => {
  const data = { member: { ...params } };
  const updatedMember = getState().members.find(({ memberId }) => memberId === params.id);
  const actionPayload = { ...omit(params, ['id']), memberId: params.id };
  dispatch({ type: 'UPDATE_MEMBER_REQUEST', payload: { member: actionPayload } });

  try {
    const response = await api.updateMember(data);
    WpToastManager.success(tr('perform.members.user_updated'));
    return response;
  } catch (error) {
    showNotificationError(error);
    dispatch({ type: 'UPDATE_MEMBER_ERROR', payload: { member: updatedMember } });
    return error;
  }
};

export const destroyMemberAction = memberId => async (dispatch, getState) => {
  const destroyedMember = getState().members.find(({ memberId: id }) => id === memberId);

  dispatch({ type: 'DESTROY_MEMBER_REQUEST', payload: { memberId } });

  try {
    const response = await api.destroyMember(memberId);
    WpToastManager.success(tr('perform.members.user_removed'));
    return response;
  } catch (error) {
    showNotificationError(error);
    dispatch({ type: 'DESTROY_MEMBER_ERROR', payload: { member: destroyedMember } });
    return null;
  }
};
